import { MagazineDto } from '@/src/models/MagazineDto';

export interface MagazineWebviewTemplate extends Partial<MagazineDto> {
  thumbnailImageBufferFullUrl: string;
  sponsorImageBufferFullUrl: string;
  thumbnailImageBufferFullUrlDisplayYn: boolean;
  subTitleDisplayYn: boolean;
  sponsorDividerDisplayYn: boolean;
  sponsorImageBufferFullUrlDisplayYn: boolean;
  sponsorDescriptionDisplayYn: boolean;
  sponsorPageLinkDisplayYn: boolean;
  adBadgeDisplayYn: boolean;
}

export const MagazineWebviewMapper = (
  data?: Partial<MagazineDto>,
): MagazineWebviewTemplate => {
  return {
    ...data,
    title: data?.title || '제목을 입력해주세요.',
    contents: data?.contents || '내용을 입력해주세요.',
    thumbnailImageBufferFullUrl: data?.thumbnailImage?.bufferFullUrl || '',
    sponsorImageBufferFullUrl: data?.sponsorImage?.bufferFullUrl || '',
    thumbnailImageBufferFullUrlDisplayYn: !!data?.thumbnailImage?.bufferFullUrl,
    subTitleDisplayYn: !!data?.subTitle,
    sponsorDividerDisplayYn:
      !!data?.sponsorImage?.bufferFullUrl ||
      !!data?.sponsorDescription ||
      !!data?.sponsorPageLink,
    sponsorImageBufferFullUrlDisplayYn: !!data?.sponsorImage?.bufferFullUrl,
    sponsorDescriptionDisplayYn: !!data?.sponsorDescription,
    sponsorPageLinkDisplayYn: !!data?.sponsorPageLink,
    adBadgeDisplayYn: data?.magazineType === 'advertising',
    bottomButtonDisplayYn:
      !!data?.bottomButtonDisplayYn &&
      !!data?.bottomButtonName &&
      !!data?.bottomButtonLink,
  };
};
